/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as SuperRouteImport } from './routes/super';
import { Route as SignupRouteImport } from './routes/signup';
import { Route as SigninRouteImport } from './routes/signin';
import { Route as OnboardingRouteImport } from './routes/onboarding';
import { Route as AppRouteImport } from './routes/app';
import { Route as IndexRouteImport } from './routes/index';
import { Route as InviteAcceptRouteImport } from './routes/invite.accept';
import { Route as AdminSlugRouteImport } from './routes/admin.$slug';
import { Route as SuperTemplatesIndexRouteImport } from './routes/super.templates.index';
import { Route as AdminSlugIndexRouteImport } from './routes/admin.$slug.index';
import { Route as SuperTemplatesIdRouteImport } from './routes/super.templates.$id';
import { Route as AdminSlugWhatsNewRouteImport } from './routes/admin.$slug.whats-new';
import { Route as AdminSlugSettingsRouteImport } from './routes/admin.$slug.settings';
import { Route as AdminSlugSandboxRouteImport } from './routes/admin.$slug.sandbox';
import { Route as AdminSlugMembersRouteImport } from './routes/admin.$slug.members';
import { Route as AdminSlugMappingRouteImport } from './routes/admin.$slug.mapping';
import { Route as AdminSlugCatalogRouteImport } from './routes/admin.$slug.catalog';
import { Route as AdminSlugAnalyticsRouteImport } from './routes/admin.$slug.analytics';
import { Route as AdminSlugConversationsIndexRouteImport } from './routes/admin.$slug.conversations.index';
import { Route as AdminSlugAgentsIndexRouteImport } from './routes/admin.$slug.agents.index';
import { Route as AdminSlugConversationsIdRouteImport } from './routes/admin.$slug.conversations.$id';
import { Route as AdminSlugAgentsAgentIdRouteImport } from './routes/admin.$slug.agents.$agentId';

const SuperRoute = SuperRouteImport.update({
  id: '/super',
  path: '/super',
  getParentRoute: () => rootRouteImport,
} as any);
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any);
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const InviteAcceptRoute = InviteAcceptRouteImport.update({
  id: '/invite/accept',
  path: '/invite/accept',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminSlugRoute = AdminSlugRouteImport.update({
  id: '/admin/$slug',
  path: '/admin/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const SuperTemplatesIndexRoute = SuperTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => SuperRoute,
} as any);
const AdminSlugIndexRoute = AdminSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSlugRoute,
} as any);
const SuperTemplatesIdRoute = SuperTemplatesIdRouteImport.update({
  id: '/templates/$id',
  path: '/templates/$id',
  getParentRoute: () => SuperRoute,
} as any);
const AdminSlugWhatsNewRoute = AdminSlugWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugSettingsRoute = AdminSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugSandboxRoute = AdminSlugSandboxRouteImport.update({
  id: '/sandbox',
  path: '/sandbox',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugMembersRoute = AdminSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugMappingRoute = AdminSlugMappingRouteImport.update({
  id: '/mapping',
  path: '/mapping',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugCatalogRoute = AdminSlugCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugAnalyticsRoute = AdminSlugAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugConversationsIndexRoute =
  AdminSlugConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AdminSlugRoute,
  } as any);
const AdminSlugAgentsIndexRoute = AdminSlugAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AdminSlugRoute,
} as any);
const AdminSlugConversationsIdRoute =
  AdminSlugConversationsIdRouteImport.update({
    id: '/conversations/$id',
    path: '/conversations/$id',
    getParentRoute: () => AdminSlugRoute,
  } as any);
const AdminSlugAgentsAgentIdRoute = AdminSlugAgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => AdminSlugRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/app': typeof AppRoute;
  '/onboarding': typeof OnboardingRoute;
  '/signin': typeof SigninRoute;
  '/signup': typeof SignupRoute;
  '/super': typeof SuperRouteWithChildren;
  '/admin/$slug': typeof AdminSlugRouteWithChildren;
  '/invite/accept': typeof InviteAcceptRoute;
  '/admin/$slug/analytics': typeof AdminSlugAnalyticsRoute;
  '/admin/$slug/catalog': typeof AdminSlugCatalogRoute;
  '/admin/$slug/mapping': typeof AdminSlugMappingRoute;
  '/admin/$slug/members': typeof AdminSlugMembersRoute;
  '/admin/$slug/sandbox': typeof AdminSlugSandboxRoute;
  '/admin/$slug/settings': typeof AdminSlugSettingsRoute;
  '/admin/$slug/whats-new': typeof AdminSlugWhatsNewRoute;
  '/super/templates/$id': typeof SuperTemplatesIdRoute;
  '/admin/$slug/': typeof AdminSlugIndexRoute;
  '/super/templates/': typeof SuperTemplatesIndexRoute;
  '/admin/$slug/agents/$agentId': typeof AdminSlugAgentsAgentIdRoute;
  '/admin/$slug/conversations/$id': typeof AdminSlugConversationsIdRoute;
  '/admin/$slug/agents/': typeof AdminSlugAgentsIndexRoute;
  '/admin/$slug/conversations/': typeof AdminSlugConversationsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/app': typeof AppRoute;
  '/onboarding': typeof OnboardingRoute;
  '/signin': typeof SigninRoute;
  '/signup': typeof SignupRoute;
  '/super': typeof SuperRouteWithChildren;
  '/invite/accept': typeof InviteAcceptRoute;
  '/admin/$slug/analytics': typeof AdminSlugAnalyticsRoute;
  '/admin/$slug/catalog': typeof AdminSlugCatalogRoute;
  '/admin/$slug/mapping': typeof AdminSlugMappingRoute;
  '/admin/$slug/members': typeof AdminSlugMembersRoute;
  '/admin/$slug/sandbox': typeof AdminSlugSandboxRoute;
  '/admin/$slug/settings': typeof AdminSlugSettingsRoute;
  '/admin/$slug/whats-new': typeof AdminSlugWhatsNewRoute;
  '/super/templates/$id': typeof SuperTemplatesIdRoute;
  '/admin/$slug': typeof AdminSlugIndexRoute;
  '/super/templates': typeof SuperTemplatesIndexRoute;
  '/admin/$slug/agents/$agentId': typeof AdminSlugAgentsAgentIdRoute;
  '/admin/$slug/conversations/$id': typeof AdminSlugConversationsIdRoute;
  '/admin/$slug/agents': typeof AdminSlugAgentsIndexRoute;
  '/admin/$slug/conversations': typeof AdminSlugConversationsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/app': typeof AppRoute;
  '/onboarding': typeof OnboardingRoute;
  '/signin': typeof SigninRoute;
  '/signup': typeof SignupRoute;
  '/super': typeof SuperRouteWithChildren;
  '/admin/$slug': typeof AdminSlugRouteWithChildren;
  '/invite/accept': typeof InviteAcceptRoute;
  '/admin/$slug/analytics': typeof AdminSlugAnalyticsRoute;
  '/admin/$slug/catalog': typeof AdminSlugCatalogRoute;
  '/admin/$slug/mapping': typeof AdminSlugMappingRoute;
  '/admin/$slug/members': typeof AdminSlugMembersRoute;
  '/admin/$slug/sandbox': typeof AdminSlugSandboxRoute;
  '/admin/$slug/settings': typeof AdminSlugSettingsRoute;
  '/admin/$slug/whats-new': typeof AdminSlugWhatsNewRoute;
  '/super/templates/$id': typeof SuperTemplatesIdRoute;
  '/admin/$slug/': typeof AdminSlugIndexRoute;
  '/super/templates/': typeof SuperTemplatesIndexRoute;
  '/admin/$slug/agents/$agentId': typeof AdminSlugAgentsAgentIdRoute;
  '/admin/$slug/conversations/$id': typeof AdminSlugConversationsIdRoute;
  '/admin/$slug/agents/': typeof AdminSlugAgentsIndexRoute;
  '/admin/$slug/conversations/': typeof AdminSlugConversationsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/app'
    | '/onboarding'
    | '/signin'
    | '/signup'
    | '/super'
    | '/admin/$slug'
    | '/invite/accept'
    | '/admin/$slug/analytics'
    | '/admin/$slug/catalog'
    | '/admin/$slug/mapping'
    | '/admin/$slug/members'
    | '/admin/$slug/sandbox'
    | '/admin/$slug/settings'
    | '/admin/$slug/whats-new'
    | '/super/templates/$id'
    | '/admin/$slug/'
    | '/super/templates/'
    | '/admin/$slug/agents/$agentId'
    | '/admin/$slug/conversations/$id'
    | '/admin/$slug/agents/'
    | '/admin/$slug/conversations/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/app'
    | '/onboarding'
    | '/signin'
    | '/signup'
    | '/super'
    | '/invite/accept'
    | '/admin/$slug/analytics'
    | '/admin/$slug/catalog'
    | '/admin/$slug/mapping'
    | '/admin/$slug/members'
    | '/admin/$slug/sandbox'
    | '/admin/$slug/settings'
    | '/admin/$slug/whats-new'
    | '/super/templates/$id'
    | '/admin/$slug'
    | '/super/templates'
    | '/admin/$slug/agents/$agentId'
    | '/admin/$slug/conversations/$id'
    | '/admin/$slug/agents'
    | '/admin/$slug/conversations';
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/onboarding'
    | '/signin'
    | '/signup'
    | '/super'
    | '/admin/$slug'
    | '/invite/accept'
    | '/admin/$slug/analytics'
    | '/admin/$slug/catalog'
    | '/admin/$slug/mapping'
    | '/admin/$slug/members'
    | '/admin/$slug/sandbox'
    | '/admin/$slug/settings'
    | '/admin/$slug/whats-new'
    | '/super/templates/$id'
    | '/admin/$slug/'
    | '/super/templates/'
    | '/admin/$slug/agents/$agentId'
    | '/admin/$slug/conversations/$id'
    | '/admin/$slug/agents/'
    | '/admin/$slug/conversations/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRoute;
  OnboardingRoute: typeof OnboardingRoute;
  SigninRoute: typeof SigninRoute;
  SignupRoute: typeof SignupRoute;
  SuperRoute: typeof SuperRouteWithChildren;
  AdminSlugRoute: typeof AdminSlugRouteWithChildren;
  InviteAcceptRoute: typeof InviteAcceptRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/super': {
      id: '/super';
      path: '/super';
      fullPath: '/super';
      preLoaderRoute: typeof SuperRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup': {
      id: '/signup';
      path: '/signup';
      fullPath: '/signup';
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signin': {
      id: '/signin';
      path: '/signin';
      fullPath: '/signin';
      preLoaderRoute: typeof SigninRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding': {
      id: '/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/app': {
      id: '/app';
      path: '/app';
      fullPath: '/app';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invite/accept': {
      id: '/invite/accept';
      path: '/invite/accept';
      fullPath: '/invite/accept';
      preLoaderRoute: typeof InviteAcceptRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/$slug': {
      id: '/admin/$slug';
      path: '/admin/$slug';
      fullPath: '/admin/$slug';
      preLoaderRoute: typeof AdminSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/super/templates/': {
      id: '/super/templates/';
      path: '/templates';
      fullPath: '/super/templates/';
      preLoaderRoute: typeof SuperTemplatesIndexRouteImport;
      parentRoute: typeof SuperRoute;
    };
    '/admin/$slug/': {
      id: '/admin/$slug/';
      path: '/';
      fullPath: '/admin/$slug/';
      preLoaderRoute: typeof AdminSlugIndexRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/super/templates/$id': {
      id: '/super/templates/$id';
      path: '/templates/$id';
      fullPath: '/super/templates/$id';
      preLoaderRoute: typeof SuperTemplatesIdRouteImport;
      parentRoute: typeof SuperRoute;
    };
    '/admin/$slug/whats-new': {
      id: '/admin/$slug/whats-new';
      path: '/whats-new';
      fullPath: '/admin/$slug/whats-new';
      preLoaderRoute: typeof AdminSlugWhatsNewRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/settings': {
      id: '/admin/$slug/settings';
      path: '/settings';
      fullPath: '/admin/$slug/settings';
      preLoaderRoute: typeof AdminSlugSettingsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/sandbox': {
      id: '/admin/$slug/sandbox';
      path: '/sandbox';
      fullPath: '/admin/$slug/sandbox';
      preLoaderRoute: typeof AdminSlugSandboxRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/members': {
      id: '/admin/$slug/members';
      path: '/members';
      fullPath: '/admin/$slug/members';
      preLoaderRoute: typeof AdminSlugMembersRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/mapping': {
      id: '/admin/$slug/mapping';
      path: '/mapping';
      fullPath: '/admin/$slug/mapping';
      preLoaderRoute: typeof AdminSlugMappingRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/catalog': {
      id: '/admin/$slug/catalog';
      path: '/catalog';
      fullPath: '/admin/$slug/catalog';
      preLoaderRoute: typeof AdminSlugCatalogRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/analytics': {
      id: '/admin/$slug/analytics';
      path: '/analytics';
      fullPath: '/admin/$slug/analytics';
      preLoaderRoute: typeof AdminSlugAnalyticsRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/conversations/': {
      id: '/admin/$slug/conversations/';
      path: '/conversations';
      fullPath: '/admin/$slug/conversations/';
      preLoaderRoute: typeof AdminSlugConversationsIndexRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/agents/': {
      id: '/admin/$slug/agents/';
      path: '/agents';
      fullPath: '/admin/$slug/agents/';
      preLoaderRoute: typeof AdminSlugAgentsIndexRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/conversations/$id': {
      id: '/admin/$slug/conversations/$id';
      path: '/conversations/$id';
      fullPath: '/admin/$slug/conversations/$id';
      preLoaderRoute: typeof AdminSlugConversationsIdRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
    '/admin/$slug/agents/$agentId': {
      id: '/admin/$slug/agents/$agentId';
      path: '/agents/$agentId';
      fullPath: '/admin/$slug/agents/$agentId';
      preLoaderRoute: typeof AdminSlugAgentsAgentIdRouteImport;
      parentRoute: typeof AdminSlugRoute;
    };
  }
}

interface SuperRouteChildren {
  SuperTemplatesIdRoute: typeof SuperTemplatesIdRoute;
  SuperTemplatesIndexRoute: typeof SuperTemplatesIndexRoute;
}

const SuperRouteChildren: SuperRouteChildren = {
  SuperTemplatesIdRoute: SuperTemplatesIdRoute,
  SuperTemplatesIndexRoute: SuperTemplatesIndexRoute,
};

const SuperRouteWithChildren = SuperRoute._addFileChildren(SuperRouteChildren);

interface AdminSlugRouteChildren {
  AdminSlugAnalyticsRoute: typeof AdminSlugAnalyticsRoute;
  AdminSlugCatalogRoute: typeof AdminSlugCatalogRoute;
  AdminSlugMappingRoute: typeof AdminSlugMappingRoute;
  AdminSlugMembersRoute: typeof AdminSlugMembersRoute;
  AdminSlugSandboxRoute: typeof AdminSlugSandboxRoute;
  AdminSlugSettingsRoute: typeof AdminSlugSettingsRoute;
  AdminSlugWhatsNewRoute: typeof AdminSlugWhatsNewRoute;
  AdminSlugIndexRoute: typeof AdminSlugIndexRoute;
  AdminSlugAgentsAgentIdRoute: typeof AdminSlugAgentsAgentIdRoute;
  AdminSlugConversationsIdRoute: typeof AdminSlugConversationsIdRoute;
  AdminSlugAgentsIndexRoute: typeof AdminSlugAgentsIndexRoute;
  AdminSlugConversationsIndexRoute: typeof AdminSlugConversationsIndexRoute;
}

const AdminSlugRouteChildren: AdminSlugRouteChildren = {
  AdminSlugAnalyticsRoute: AdminSlugAnalyticsRoute,
  AdminSlugCatalogRoute: AdminSlugCatalogRoute,
  AdminSlugMappingRoute: AdminSlugMappingRoute,
  AdminSlugMembersRoute: AdminSlugMembersRoute,
  AdminSlugSandboxRoute: AdminSlugSandboxRoute,
  AdminSlugSettingsRoute: AdminSlugSettingsRoute,
  AdminSlugWhatsNewRoute: AdminSlugWhatsNewRoute,
  AdminSlugIndexRoute: AdminSlugIndexRoute,
  AdminSlugAgentsAgentIdRoute: AdminSlugAgentsAgentIdRoute,
  AdminSlugConversationsIdRoute: AdminSlugConversationsIdRoute,
  AdminSlugAgentsIndexRoute: AdminSlugAgentsIndexRoute,
  AdminSlugConversationsIndexRoute: AdminSlugConversationsIndexRoute,
};

const AdminSlugRouteWithChildren = AdminSlugRoute._addFileChildren(
  AdminSlugRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRoute,
  OnboardingRoute: OnboardingRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  SuperRoute: SuperRouteWithChildren,
  AdminSlugRoute: AdminSlugRouteWithChildren,
  InviteAcceptRoute: InviteAcceptRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
